// Packages
import React from "react";
import { Link } from "react-router-dom";

// Styles
import "./schoolAdmin.css";

// Material Ui
import MaterialTable from "material-table";

// Services
import userService from "../../services/user.service";

// Assets
import menuthree from "../../assets/images/menuthree.png";
import backArrow from "../../assets/images/backArrow.png";
import bluePlayStream from "../../assets/images/bluePlayStream.png";

// Views
import SchoolAdminDashboard from "./schoolAdminDashboard";

// const data = [
//   {
//     id: "100",
//     schoolName: "Ross Taylor",
//     totalStorage: "2020-01-01 12:05 PM",
//     remaining: "27",
//     remainingper: "Coach",
//     lastModifed: "+44-8927471190",
//     status: "Active",
//   },

//   {
//     id: "100",
//     schoolName: "Ross Taylor",
//     totalStorage: "2020-01-01 12:05 PM",
//     remaining: "27",
//     remainingper: "Head Coach",
//     lastModifed: "+44-8927471190",
//     status: "Active",
//   },

//   {
//     id: "100",
//     schoolName: "Ross Taylor",
//     totalStorage: "2020-01-01 12:05 PM",
//     remaining: "27",
//     remainingper: "Coach",
//     lastModifed: "+44-8927471190",
//     status: "Active",
//   },

//   {
//     id: "100",
//     schoolName: "Ross Taylor",
//     totalStorage: "2020-01-01 12:05 PM",
//     remaining: "27",
//     remainingper: "Head Coach",
//     lastModifed: "+44-8927471190",
//     status: "Active",
//   },

//   {
//     id: "100",
//     schoolName: "Ross Taylor",
//     totalStorage: "2020-01-01 12:05 PM",
//     remaining: "27",
//     remainingper: "Coach",
//     lastModifed: "+44-8927471190",
//     status: "Active",
//   },
// ];

const columns = [
  {
    title: "id",
    field: "id",
    hidden: true,
  },
  {
    title: "PLAYED AGAINST",
    field: "firstName",
  },

  // {title:'', field:'firstName'},
  // {title:'NAME', field:'firstName'},
  {
    title: "SEASON",
    field: "lastName",
    type: "date",
    dateSetting: { locale: "en-US" },
  },
  {
    title: "DATE & TIME",
    field: "email",
  },
  {
    title: "EVENT TYPE",
    field: "createdAt",
  },
  {
    title: "RESULT",
    field: "specialty",
  },
  {
    title: "STREAM",
    field: "10",
    render: (row) => (
      <Link to={`/schoolgamehistory/${row.id}`}>
        <div className="txtblue" key={row.id}>
          <img className="cp" src={bluePlayStream} alt="menu" /> Video Library
        </div>
      </Link>
    ),
  },
  {
    render: (rowData) => (
      <div class="dropdown">
        <span className="cp three-dot pr-2">
          <img className="cp" src={menuthree} alt="menu" />{" "}
        </span>
        <div class="dropdown-content">
          <Link className="p-0" to={`/editteams/${rowData.id}`}></Link>
        </div>
      </div>
    ),
  },
];

class Storage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allSchoolList: [],
    };
  }
  componentDidMount() {
    this.getSchoolData();
  }

  getSchoolData() {
    userService
      .getAllCoaches()
      .then((response) => {
        console.log(response);
        var allSchoolList = response.data.data.coaches;
        console.log(allSchoolList);
        this.setState({ allSchoolList });
      })
      .catch((error) => {
        console.error("There was an error!", error);
      });
  }
  render() {
    return (
      <div className="content">
        <div className="content-layout p-0">
          <SchoolAdminDashboard />
          <div className="container">
            <div className="row">
              <div className="col-6 col-sm-6 col-md-6 col-lg-6 top-strip pt-28">
                <p>
                  <Link to="/schoolteams">
                    <span className="fs-22 black semi-bold">TEAMS</span>
                  </Link>{" "}
                  <img src={backArrow} alt="" />{" "}
                  <span>San Francisco: Game History</span>
                </p>
              </div>
              <div className="col-6 col-sm-6 col-md-6 col-lg-6 top-strip pt-28">
                <div className="row">
                  <div className="col-6 col-sm-6 col-md-6 col-lg-6 text-right"></div>
                  <div className="col-6 col-sm-6 col-md-6 col-lg-6 text-right"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="clear20"></div>

          <div className="col-12 col-sm-12 col-md-12 col-lg-12">
            <MaterialTable
              title=""
              data={this.state.allSchoolList}
              columns={columns}
              options={{
                // filtering: true,
                selection: true,
                headerStyle: { fontFamily: "Rajdhani-Bold", fontSize: 14 },
                rowStyle: { fontSize: 17, fontFamily: "Rajdhani-SemiBold" },
                // rowStyle: rowData => ({ backgroundColor: rowData.tableData.checked ? '#37b15933' : '' }),
                // paging:true,
                pageSize: 10,
                // emptyRowsWhenPaging: true,
                // pageSizeOptions:[5,20,40,60,80,100],
              }}
            ></MaterialTable>
          </div>
        </div>
      </div>
    );
  }
}
export default Storage;
